import { render, staticRenderFns } from "./ViewSeedingTaskDetail.vue?vue&type=template&id=35bfbd90&scoped=true"
import script from "./ViewSeedingTaskDetail.vue?vue&type=script&lang=js"
export * from "./ViewSeedingTaskDetail.vue?vue&type=script&lang=js"
import style0 from "./ViewSeedingTaskDetail.vue?vue&type=style&index=0&id=35bfbd90&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35bfbd90",
  null
  
)

export default component.exports